<template>
    <div>
        <div class="bg-little-gray p-4" v-if="records.length > 0">
            <table class="table table-scroll-sm table-fit table-borderless mb-0">
                <thead>
                <tr>
                    <th class="align-middle w-25">
                        Název kontaktu
                    </th>
                    <th class="align-middle w-25">
                        Telefonní číslo
                    </th>
                    <th class="align-middle">
                        Elektronická adresa
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="record in records" v-bind:key="record.id" class="border-top">
                    <td class="align-middle">
                        {{ record.name }}
                    </td>
                    <td class="align-middle">
                        {{ record.phone }}
                    </td>
                    <td class="align-middle">
                        {{ record.email }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <TableWithoutRecords v-else/>

    </div>
</template>

<script>
import TableWithoutRecords from "@/Module/Common/UI/Table/TableWithoutRecords.vue"

export default {

    components: {
        TableWithoutRecords,
    },

    props: {
        records: {
            required: true,
        },
    },

}
</script>
